import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle, HelpCircle, Phone } from "lucide-react";
import { gapi, errMsg, fmtEuro } from "../api";
import { MATCH_STATI, MATCH_TONE } from "../labels";
import { Badge } from "./ui";
import { fileUrl } from "@/lib/api";

export const CATEGORIE = { completa: ["green", "Compatibilità completa"], parziale: ["amber", "Compatibilità parziale"], da_verificare: ["blue", "Informazioni da verificare"] };

export function Criteri({ m }) {
  return (
    <div className="mt-2 flex flex-wrap gap-1.5 text-[11px]" data-testid="match-criteria">
      {m.soddisfatti.map((c) => <span key={c.criterio} className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-800 px-2 py-0.5"><CheckCircle2 className="h-3 w-3" />{c.label}{c.dettaglio ? `: ${c.dettaglio}` : ""}</span>)}
      {m.mancanti.map((c) => <span key={c.criterio} className="inline-flex items-center gap-1 rounded-full bg-red-50 text-red-700 px-2 py-0.5" data-testid="match-ko"><XCircle className="h-3 w-3" />{c.label}{c.dettaglio ? `: ${c.dettaglio}` : ""}</span>)}
      {(m.daVerificare || []).map((c) => <span key={c.criterio} className="inline-flex items-center gap-1 rounded-full bg-sky-50 text-sky-800 px-2 py-0.5" data-testid="match-verify"><HelpCircle className="h-3 w-3" />{c.label}: da verificare</span>)}
    </div>
  );
}

function Head({ m, mode }) {
  const cat = CATEGORIE[m.categoria] || CATEGORIE.da_verificare;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-lg font-semibold text-brand" data-testid="match-score">{m.score}%</span>
      <Badge tone={cat[0]} testid="match-category">{cat[1]}</Badge>
      {mode === "immobili"
        ? <Link to={`/gestionale/immobili/${m.propertyId}`} className="font-semibold hover:underline truncate">{m.immobile.codiceRif} · {m.immobile.titolo}</Link>
        : <Link to={m.requestId ? `/gestionale/richieste/${m.requestId}` : `/gestionale/contatti/${m.contactId}`} className="font-semibold hover:underline">{m.contattoNome || "Acquirente"}</Link>}
      {mode === "immobili" && <span className="text-xs text-anthracite/50">{fmtEuro(m.immobile.prezzo)} · {m.immobile.comune}</span>}
      {mode !== "immobili" && m.telefono && <a href={`tel:${m.telefono}`} className="inline-flex items-center gap-1 text-xs text-brand" data-testid="match-call"><Phone className="h-3 w-3" />{m.telefono}</a>}
      {m.nonPiuCompatibile && <Badge tone="red">non più compatibile</Badge>}
    </div>
  );
}

export default function MatchList({ items, mode, onChange, readOnly = false }) {
  if (!items) return <p className="text-sm text-anthracite/45">Caricamento…</p>;
  if (!items.length) return <p className="text-sm text-anthracite/45" data-testid="matches-empty">Nessun abbinamento compatibile al momento.</p>;
  const setStato = async (m, stato) => {
    let motivo = "";
    if (stato === "non_interessato") { motivo = window.prompt("Motivo del non interesse"); if (!motivo) return; }
    try { await gapi.patch(`/matches/${m.id}`, { stato, motivo }); toast.success("Esito salvato"); onChange?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  const groups = Object.keys(CATEGORIE).map((k) => [k, items.filter((m) => (m.categoria || "da_verificare") === k)]).filter(([, l]) => l.length);
  return (
    <div className="space-y-4" data-testid="matches-list">
      {groups.map(([k, list]) => (
        <div key={k} data-testid={`matches-group-${k}`}>
          <p className="text-xs font-semibold uppercase tracking-wider text-anthracite/55 mb-2">{CATEGORIE[k][1]} · {list.length}</p>
          <ul className="space-y-3">{list.map((m) => (
            <li key={m.id || m.requestId} className={`rounded-xl border p-3 ${m.nonPiuCompatibile ? "border-dashed opacity-60" : "border-border-subtle"}`} data-testid="match-item">
              <div className="flex gap-3 items-start">
                {mode === "immobili" && m.immobile?.copertina && <img src={fileUrl(m.immobile.copertina)} alt="" className="h-14 w-20 rounded-lg object-cover shrink-0" />}
                <div className="flex-1 min-w-0"><Head m={m} mode={mode} /><Criteri m={m} />
                  {m.motivo && m.stato === "non_interessato" && <p className="text-xs text-red-700 mt-1">Motivo: {m.motivo}</p>}</div>
                {!readOnly && m.id && <select value={m.stato} onChange={(e) => setStato(m, e.target.value)} className="h-9 rounded-lg border border-border-subtle px-2 text-xs" data-testid="match-status">
                  {Object.entries(MATCH_STATI).map(([s, l]) => <option key={s} value={s}>{l}</option>)}</select>}
              </div>
              {m.id && <div className="mt-2"><Badge tone={MATCH_TONE[m.stato]}>{MATCH_STATI[m.stato]}</Badge></div>}
            </li>))}</ul>
        </div>))}
    </div>
  );
}
